"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityObserver = void 0;
const types_1 = require("./types");
class VisibilityObserver {
    #summaryBuilder;
    #eventSender;
    #observer;
    #eventStore = new Map();
    #callbackStore = new Map();
    constructor(summaryBuilder, eventSender) {
        this.#summaryBuilder = summaryBuilder;
        this.#eventSender = eventSender;
        this.#observer = new IntersectionObserver(this.#intersectionObserverCallback.bind(this));
    }
    observe(htmlElement, eventData, callbackFunction) {
        this.#eventStore.set(htmlElement, eventData);
        if (callbackFunction)
            this.#callbackStore.set(htmlElement, callbackFunction);
        this.#observer.observe(htmlElement);
    }
    async #intersectionObserverCallback(entries) {
        for (const entry of entries) {
            const targetElement = entry.target;
            if (!entry.isIntersecting)
                return;
            const eventData = this.#eventStore.get(targetElement);
            eventData.type = types_1.EventType.VISIBLE;
            const callbackFunction = this.#callbackStore.get(targetElement);
            try {
                this.#eventSender.sendEvent(eventData);
                if (callbackFunction)
                    callbackFunction();
            }
            catch (error) {
                this.#summaryBuilder.appendClientWarningMessages("Links and buttons - IntersectionObserver event sending error: " + error?.toString());
            }
            finally {
                this.#observer.unobserve(targetElement);
            }
        }
    }
}
exports.VisibilityObserver = VisibilityObserver;
